import { useEffect, useState } from "react";
import { _DocumentFactory, _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { AccountEditor } from "../../../editor/AccountEditor";
import { _EmployeeVacProvision } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { WelfareEntityTypeConstantsSelector } from "../ImportedPayrollBeneficiary/WelfareEntityTypeConstants";
import { PayrollMonthsConstantsEditor } from "../EmployeeBonus/Editors/PayrollMonthsConstants.editor";
import { InputMoney } from "../../../theme/Input/InputMoney";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";


export const EmployeeVacProvision = () => {

    const vacprovision = useDataBean(_EmployeeVacProvision);
    const single = Singleton.getInstance();
    const _documentos = useDataBean(_DocumentFactory);
    const [Account, setAccount] = useState<any>(null);
    const [docs, setDocs] = useState<any>([]);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);

    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modal = useModal("", MODAL_LG)
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {
        if (!Account) {
            toast.warning("Debe seleccionar un empleado.");
            return;
        }

        if (!year) {
            toast.warning("Debe seleccionar un año.");
            return;
        }
        vacprovision.instance.getDetailedFortnightVacProcessByAccount(Account, year, month).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        vacprovision.setBean({
            // IDAccount: _single.getAccountID()
        });
        modal.open("Agregar Anticipo");
    }
    const deleteItem = () => {
        vacprovision.instance.deleteFortnightVacProcess(vacprovision.bean.IDVacProvision).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (!vacprovision.bean.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        if (!vacprovision.bean.IDEmployee) {
            toast.warning("Debe seleccionar un Empleado.");
            return;
        }
        if (!vacprovision.bean.Month) {
            toast.warning("Debe seleccionar un Mes.");
            return;
        }
        if (typeof (vacprovision.bean.WelfareType) != "number") {
            toast.warning("Debe seleccionar un Tipo Aporte.");
            return;
        }
        if (!vacprovision.bean.TotalValue) {
            toast.warning("Debe seleccionar un Valor Aporte.");
            return;
        }
        vacprovision.instance.updateEmployeeVacProvision(vacprovision.bean).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const verDocumentos = () => {

        if (vacprovision.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(vacprovision.bean.IDDocument, null, vacprovision.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const head = [
        { title: 'ID', property: 'IDVacProvision', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
        { title: 'Fondo Anticipo', property: 'AccountName', visible: true },
        { title: 'Vigencia', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Tipo Aporte', property: 'WelfareTypeName', visible: true },
        { title: 'Valor Aporte', property: 'TotalValue', visible: true, mask: MASK_MONEY },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha de Documento', property: 'DocumentDate', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit() && !vacprovision.bean.IDDocument, evento: () => { modal.open("Editar Anticipo") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Anticipos de Vacaciones">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Empleado" />
                </div>
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <PayrollMonthsConstantsEditor idSelector={month} onChange={(e) => { setmonth(e) }} label="Mes" />
                </div>

                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={vacprovision.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <AccountEditor idAccount={vacprovision.bean.IDEmployee} onChange={(e) => vacprovision.setBean({ ...vacprovision.bean, "IDEmployee": e.IDAccount })} label="Empleado" />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={vacprovision.bean.IDAccount} onChange={(e) => vacprovision.setBean({ ...vacprovision.bean, "IDAccount": e.IDAccount })} label="Fondo Anticipo" />
                            </div>
                            <div className="col-md-6">
                                <YearSelector value={vacprovision.bean.Year} onChange={(e) => vacprovision.setBean({ ...vacprovision.bean, "Year": e })} />
                            </div>
                            <div className="col-md-6">
                                <PayrollMonthsConstantsEditor label='Mes' idSelector={vacprovision.bean.Month} onChange={(e) => vacprovision.setBean({ ...vacprovision.bean, "Month": e })} />
                            </div>

                            <div className="col-md-6">
                                <WelfareEntityTypeConstantsSelector label='Tipo Aporte' idSelector={vacprovision.bean.WelfareType} onChange={(e) => vacprovision.setBean({ ...vacprovision.bean, "WelfareType": e })} />
                            </div>
                            <div className="col-md-6">

                                <InputMoney _label="Valor Aporte" _value={vacprovision.bean.TotalValue} onChange={(e) => vacprovision.setBean({ ...vacprovision.bean, "TotalValue": e })} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                    IDDocument={vacprovision.bean.IDDocument}
                                    Since={vacprovision.bean.DocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {vacprovision.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}